import { render, staticRenderFns } from "./resources-menu.vue?vue&type=template&id=6b4b8104&scoped=true"
import script from "./resources-menu.vue?vue&type=script&lang=js"
export * from "./resources-menu.vue?vue&type=script&lang=js"
import style0 from "./resources-menu.vue?vue&type=style&index=0&id=6b4b8104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4b8104",
  null
  
)

export default component.exports